import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'


declareVconsoleComponent('translate25Admin', () => import('./components/Translate25Admin.vue'), 'translate25_admin:page')